import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

const WebCategoryInfo = ({ webMonitoringData, deviceSelected, getLangTranslation }) => {
    const history = useHistory();

    function getRestrictedWebsiteStatus() {
        const webCategory = webMonitoringData?.webCategory;
        let blockCategories = 0;

        webCategory?.forEach((item) => {
            if((item?.considerAdminChanges && item?.blockedByAdmin === 1) || (item?.categoryStatus === 1)) {
                blockCategories++;
            }
        })

        return `Restricting ${blockCategories} of ${webCategory?.length || 0}`;
    }
    const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
    const { appLanguageId } = useSelector(({ misc }) => misc);
    const lang = AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find((item) => item?.id === appLanguageId);

    return (
        <div className='g-col-12 g-col-lg-4' onClick={() => history.push({pathname: '/set-rules/web-categories', state: {device: deviceSelected}})}>
            <div className='d-flex align-items-center justify-content-center pt-cursor flex-wrap p-6 text-blue-400 border rounded-3 bg-gray-300 h-100 gap-3' >
                <div className='d-flex flex-column'>
                    <span className='text-uppercase fw-bold d-flex align-items-center'>{getLangTranslation("WEB_SUPERVISION_WEB_CATEGORY", "Web categories")} <i className={`fs-5 ${lang?.isRTL === 1 ? 'icon-arrow-left' : 'icon-arrow-right'}`} /></span>
                    <p className='w-100 text-dark fw-semibold mb-0'>{getRestrictedWebsiteStatus()}</p>
                </div>
            </div>
        </div>
    )
}

export default WebCategoryInfo;